import { Component, OnInit } from '@angular/core';
import { Campaign } from '../../models/campaign';
import { CampaignService } from '../../services/campaign.service';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FileService } from '../../services/file.service';
import { UserService } from '../../services/user.service';
import { CompanyService } from '../../services/company.service';
import { Company } from '../../models/company';

@Component({
  selector: 'app-campaigns',
  imports: [FormsModule, CommonModule, RouterModule],
  templateUrl: './campaigns.component.html',
  styleUrl: './campaigns.component.css'
})
export class CampaignsComponent implements OnInit{
  campaigns: Campaign[] = [];
  showAddNewCampaign: boolean = false;
  showUploadEmail: boolean = false;
  newCampaign?: Campaign;

  companies: Company[] = [];

  constructor(private campaignService: CampaignService, private fileService: FileService, private userService: UserService, private companyService: CompanyService) {}

  getBrandName(brandId: string | undefined): string {
    if (!brandId) return '';
    return this.companies.find(c => c.id === brandId)?.name ?? '';
  }

  resolveUserId(id: string): string { return this.userService.resolveUserId(id); }

  ngOnInit(): void {
    this.campaignService.getCampaigns().subscribe({
      next: (result) => {
        this.campaigns = result;
      },
      error: (err) => {
        console.log(err);
      }
    });
    this.companyService.getCompanies().subscribe(companies => { this.companies = companies; });
  }

  AddCampaign() {

  }

}
